// WP-17 (US 6.2, LLD-05 O-02 bell) — the persistent notification feed contract
// (mirror of apps/api/src/notifications — LLD owns the shape; the SPA consumes).
export type NotificationType =
  | "DELAY"
  | "COMPLETION"
  | "QUOTE_CHASE"
  | "QUOTE_EXPIRING"
  | "STORAGE_QUOTA"
  | "INVOICE_FLAG"
  // WP-32 (US 4.1 edge case) — an open check-in past checkout.reminderAfterMinutes.
  | "FORGOTTEN_CHECKOUT";

export interface NotificationDto {
  id: string;
  type: NotificationType;
  message: string;
  entityType: string;
  entityId: string | null;
  createdAt: string;
  readAt: string | null;
}

export interface NotificationFeedDto {
  notifications: NotificationDto[];
  unreadCount: number;
}

/** Deep-link target for a notification's entity (deep-links to the job/quote). */
export function notificationLink(n: NotificationDto): string {
  if (n.entityType === "job" && n.entityId) return `/jobs/${n.entityId}`;
  if (n.entityType === "quote" && n.entityId) return `/quotes/${n.entityId}`;
  if (n.entityType === "org") return "/settings/organization";
  return "/dashboard";
}

/**
 * UX-4a (lane row 96, presentation guard): the text the bell SHOWS for a
 * notification. Some producers author one `message` for both the email and
 * the bell and end it with ` (https://…)` (the WP-32 FORGOTTEN_CHECKOUT copy);
 * the bell item is already a link to that entity, so a trailing parenthesised
 * URL is dropped from the display (a trailing full stop is kept). Only a URL
 * at the very END is stripped — a URL mid-sentence is left alone. The producer
 * fix (a plain `message`, the email appends the link) is UX-6.
 */
export function notificationDisplayMessage(message: string): string {
  return message.replace(/\s*\(https?:\/\/[^\s()]+\)(?=\s*\.?\s*$)/, "").trimEnd();
}
